import { API_BASE } from '../services/api';

// Uploaded files are served by the API host at /uploads (backend/server.js),
// while the API itself sits under /api on that same host.
const FILE_ORIGIN = API_BASE.replace(/\/api\/?$/, '');

/**
 * Absolute URL for a stored file.
 *
 * Uploads keep only multer's UUID filename in the database (news.cover_image,
 * ad_media.file_path), so they need the /uploads prefix. Ingested news rows
 * already hold a full URL in image_url — anything absolute passes through
 * untouched. Returns null when there is nothing to show.
 */
export const mediaUrl = (file) => {
  if (!file) return null;
  const v = String(file).trim();
  if (!v) return null;
  if (/^(https?:)?\/\//i.test(v) || v.startsWith('data:')) return v;
  return `${FILE_ORIGIN}/uploads/${v.replace(/^\/*(uploads\/)?/i, '')}`;
};

/**
 * The image for a news row: the uploaded cover wins, and an article pulled in
 * by the ingestion job falls back to its remote image_url.
 */
export const newsImage = (news) => mediaUrl(news?.cover_image) || mediaUrl(news?.image_url);

/** An ad's creatives, resolved to absolute URLs and tagged image vs video. */
export const adMediaList = (ad) =>
  (ad?.media || [])
    .map((m) => ({ ...m, url: mediaUrl(m.file_path), isVideo: m.file_type === 'video' }))
    .filter((m) => m.url);

/** The still image an ad card leads with, or null when it only has video. */
export const adImage = (ad) => adMediaList(ad).find((m) => !m.isVideo)?.url || null;
